import OEIconCodes from '../../../lib/oe-icon-codes';
import {OETargetMenuDefs} from '../../elements/target-menu/oe-target-menu-defs';
import {OEAlphaBetaProdTypes} from '../oe-proto-model';

export const OESkinTargetType = {
    anatomy:        'anatomy'
};

OESkinTargetType.all = [
    OESkinTargetType.anatomy
];

export const OESkinStartSelectionContent = {

    // alpha
    [OESkinTargetType.anatomy]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanSkinMacro,
                        OETargetMenuDefs.humanSkinMicro
                    ]
                }
            ]
        }
    ],

    // beta
    [OESkinTargetType.anatomy + OEAlphaBetaProdTypes.beta]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanSkinMacro,
                        OETargetMenuDefs.humanSkinMicro
                    ]
                }
            ]
        }
    ],

    // prod
    [OESkinTargetType.anatomy + OEAlphaBetaProdTypes.prod]: [
        {
            subcategories: [
                {
                    items: [
                        OETargetMenuDefs.humanSkinMacro,
                        OETargetMenuDefs.humanSkinMicro
                    ]
                }
            ]
        }
    ]
};

OESkinStartSelectionContent.modules = [
    {id: OESkinTargetType.anatomy, icon: OEIconCodes.skin.anatomyTarget, categories: OESkinStartSelectionContent[OESkinTargetType.anatomy]},
];

OESkinStartSelectionContent.modulesBeta = [
    {id: OESkinTargetType.anatomy, icon: OEIconCodes.skin.anatomyTarget, categories: OESkinStartSelectionContent[OESkinTargetType.anatomy + OEAlphaBetaProdTypes.beta]},
];

OESkinStartSelectionContent.modulesProduction = [
    {id: OESkinTargetType.anatomy, icon: OEIconCodes.skin.anatomyTarget, categories: OESkinStartSelectionContent[OESkinTargetType.anatomy + OEAlphaBetaProdTypes.prod]},
];
